import { Rules } from 'src/lib/permission/types';
import {adminRuleSet} from "./admin";

export const rolRules: Rules[] = [
  adminRuleSet,
];
